/* @refresh reload */
import * as Sentry from '@sentry/solid'
import { render } from 'solid-js/web'

import './index.css'
import App from './App'
import { ServiceRegistry } from 'solid-services'

const isProd = import.meta.env.MODE === 'production'

Sentry.init({
	dsn: 'https://5d991838e1a8f71c6199b567f4456bfc@o4509551392522240.ingest.us.sentry.io/4509551393898496',
	environment: import.meta.env.MODE, // 'development', 'production', etc.
	tracesSampleRate: isProd ? 0.2 : 1.0,
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true,
})

const root = document.getElementById('page')

if (import.meta.env.DEV && !(root instanceof HTMLElement)) {
	throw new Error(
		'Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got misspelled?',
	)
}

render(() => <App />, root!)
